'use client';

import dynamic from 'next/dynamic';
import React from 'react';

const MetaPixel = dynamic(() => import('@/app/utils/ReactPixel'), { ssr: false });

const MetaPixelWrapper = () => {
  return <MetaPixel />;
};

export default MetaPixelWrapper;